
/**
 *  Debugging / Development Helper
 *
 *  Removes duplicate stylesheets as soon as
 *  the dom has loaded, this also means that
 *  no stylesheet will even attempt to load.
 */


document.addEventListener('DOMContentLoaded',deduplicateStylesheets);


const { debug } = console;

function deduplicateStylesheets (){


    const stylesheets = document
        .querySelectorAll('[ rel = stylesheet ]')


    const urls = new Set;

    let externalCount = 0;

    for ( const stylesheet of stylesheets ){

        const { href } = stylesheet;

        if( urls.has(href) ){
            stylesheet.remove();
            externalCount++;
        }

        urls.add(href);
    }


    const ids = new Set;

    const tags = document
        .querySelectorAll('style')

    let internalCount = 0;

    for ( const tag of tags ){

        const { stylesheet } = tag.dataset;

        if( ! stylesheet )
            continue

        if( ids.has(stylesheet) ){
            internalCount++;
            tag.remove();
        }

        ids.add(stylesheet);
    }

    debug(
        `Removed ( ${ externalCount } ) external + ( ${
        internalCount } ) internal duplicate stylesheets.` )
}
